
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import SimpleDialog from "@/components/SimpleDialog.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiStore,
  mdiDomain,
} from "@mdi/js";
import { CONNECTED_BOX_PROVIDERS } from "../../utils/connectedBoxes";

@Component({
  components: {
    SimpleDialog,
    SvgIcon,
  },
})
export default class RelaySelectConnectedBox extends Vue {

  @Prop({default: false})
  public loading: boolean;

  @Prop({default: () => []})
  public connectedBoxes: Array<{
    value: number,
    text: string,
    disabled: string,
  }>;

  @Getter private isMobile: boolean;

  private selectedConnectedBoxId: number = null;
  private loadingConfirmation: boolean = false;
  private mdiStore = mdiStore;
  private mdiDomain = mdiDomain;
  private connectedBoxesProviders = CONNECTED_BOX_PROVIDERS;

  get availableConnectedBoxes(): any[] {
    return this.connectedBoxes.filter(({disabled}) => !disabled);
  }

  private cancel(): void {
    this.$emit("cancel");
    this.selectedConnectedBoxId = null;
  }

  private confirm(): void {
    this.loadingConfirmation = true;
    this.$emit("confirm", this.selectedConnectedBoxId);
    this.selectedConnectedBoxId = null;
  }
}
